// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3RIPm","alertIcon":"ConfirmModal_alertIcon__3YcBv"};